import { Alert, Button, List, ListRow, Section, Spinner, Stack, useToast } from '@ui';
import { useTranslation } from 'react-i18next';
import { errorMessage } from '../../../lib/errors';
import { formatDate, formatDateTime } from '../../../lib/format';
import { useRevokeSession, useSessions } from '../api';

/** Signed-in devices (AUTH-007). */
export function SessionsPage() {
  const { t } = useTranslation();
  const toast = useToast();
  const sessions = useSessions();
  const revoke = useRevokeSession();

  return (
    <Stack gap={6}>
      {sessions.error && <Alert tone="danger">{errorMessage(sessions.error)}</Alert>}
      {revoke.error && <Alert tone="danger">{errorMessage(revoke.error)}</Alert>}
      {sessions.isPending && <Spinner label={t('common.loading')} />}
      {sessions.data && (
        <Section title={t('sessions.title')}>
          <List>
            {sessions.data.map((s) => {
              const device = s.device ?? t('sessions.unknownDevice');
              return (
                <ListRow
                  key={s.id}
                  title={device}
                  description={[
                    s.kind === 'api' ? t('sessions.app') : null,
                    t('sessions.lastSeen', { date: formatDateTime(s.last_seen_at) }),
                    t('sessions.since', { date: formatDate(s.created_at) }),
                  ]
                    .filter(Boolean)
                    .join(' · ')}
                  trailing={
                    s.current ? (
                      t('sessions.current')
                    ) : (
                      <Button
                        variant="plain"
                        size="sm"
                        aria-label={`${t('sessions.revoke')}: ${device}`}
                        loading={revoke.isPending && revoke.variables === s.id}
                        onClick={() =>
                          revoke.mutate(s.id, {
                            onSuccess: () => toast.show(t('sessions.revoked')),
                          })
                        }
                      >
                        {t('sessions.revoke')}
                      </Button>
                    )
                  }
                />
              );
            })}
          </List>
        </Section>
      )}
    </Stack>
  );
}
